module.exports = __webpack_public_path__ + "img/hr-inserter-hand-closed.0b4d807e.png";